import React from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { Button, Spinner } from "react-bootstrap";
import google from "../../../assets/images/google.svg"
import { setLoadingAuth } from "../userSlice";
import { useDispatch } from "react-redux";

interface Props {
    loggingIn: boolean;
    loggingName: string;
    setLoggingIn: (val: boolean) => void;
    setLoggingName: (val: string) => void;
    handleGetUser: (user: any) => void;
}

export const GoogleLoginButton: React.FC<Props> = ({
    loggingIn,
    loggingName,
    setLoggingName,
    handleGetUser,
}) => {
    const dispatch = useDispatch();

    const login = useGoogleLogin({
        onSuccess: (codeResponse: any) => {
            setLoggingName("oneclick");
            dispatch(setLoadingAuth(true));
            handleGetUser(codeResponse);
        },
        onError: (error) => console.error("Login Failed:", error),
        scope: "profile email",
    });

    const isWebView = () => {
        const ua = navigator.userAgent || navigator.vendor || "";

        const isAndroidWebView = /\bwv\b/.test(ua) || /Version\/[\d.]+ Chrome\/[\d.]+ Mobile Safari\/[\d.]+/.test(ua);

        const isIOS = /iPhone|iPad|iPod/.test(ua);
        const isSafari = /Safari/.test(ua);
        const isIOSWebView = isIOS && !isSafari;

        return isAndroidWebView || isIOSWebView;
    };

    const isIOS = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod|macintosh/i.test(userAgent);
    }

    const handleClick = () => {
        if (isWebView()) {
            const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
            const redirectUri = encodeURIComponent(`${process.env.REACT_APP_WEB_URL}auth/google-callback`);
            const scope = encodeURIComponent("openid profile email");
            const state = encodeURIComponent("webview_flow");

            const oauthUrl =
                `https://accounts.google.com/o/oauth2/v2/auth` +
                `?client_id=${clientId}` +
                `&redirect_uri=${redirectUri}` +
                `&response_type=token` +
                `&scope=${scope}` +
                `&prompt=select_account` +
                `&include_granted_scopes=true` +
                `&flowName=GeneralOAuthFlow` +
                `&state=${state}`;

            if (isIOS()) {
                window.open(oauthUrl, "_system");
            } else {
                window.open(oauthUrl, "_blank");
            }

        } else {
            login();
        }
    };

    return (
        <Button
            variant="white"
            disabled={loggingIn}
            className="google-btn w-100 mb-3 border border-primary bg-white text-black"
            onClick={handleClick}
        >
            <img src={google} alt="Google logo" loading="lazy" style={{ height: '30px', marginRight: '10px' }} />
            {(loggingIn && loggingName === "oneclick") ?
                <>
                    Continue with Google ...&nbsp;&nbsp;
                    <Spinner animation="border" as="span" size="sm" />
                </> : 'Continue with Google'
            }
        </Button>
    );
};